import { Navigate, useParams } from 'react-router-dom';
import { useApiQuery } from '../api/useApiQuery';
import { ApiRequestError } from '../api/client';
import { routes } from '../lib/links';
import { ErrorBanner } from '../components/ui/ErrorBanner';
import { FullPageSpinner } from '../components/ui/Spinner';
import { NotFoundPage } from './NotFoundPage';

/**
 * Resolver behind `/customers/<account>/sites/<party site number>` (spec 2026-10-20): the
 * Collections Assistant links a Lien Tracking row here because the party site number is the only
 * job key it holds. The server maps it, scoped to the account, to the site id of the ordinary job
 * page and this page redirects there (replace, so the resolver never sits in history). Nothing is
 * rendered of its own beyond the spinner, the not-found explanation, or an error.
 */
export function CustomerSitePage() {
  const { accountNumber = '', partySiteNumber = '' } = useParams();
  const query = useApiQuery((api, signal) => api.customers.site(accountNumber, partySiteNumber, signal), [accountNumber, partySiteNumber]);

  if (query.loading) return <FullPageSpinner label="Loading job" />;
  if (query.error) {
    if (query.error instanceof ApiRequestError && query.error.isNotFound) {
      return (
        <NotFoundPage
          what="job"
          detail={`ERP Attach has no job folder for site ${partySiteNumber} under customer ${accountNumber}. New jobs appear within about 10 minutes of being created in Oracle; a job billed through a different customer account is filed under that account.`}
        />
      );
    }
    return <ErrorBanner title="Job could not be resolved" error={query.error} />;
  }
  if (!query.data) return null;
  return <Navigate replace to={routes.job(query.data.siteId)} />;
}
